import { useParams } from 'react-router-dom';
import {
  Button,
  Divider,
  Drawer,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useFormik } from 'formik';
import { Close } from '@mui/icons-material';
import { useAppDispatch } from '@/hooks';
import { Avatar } from '@/types';
import { createAvatar, updateAvatar } from '../../slice';
import { MediaManager } from '@/components';
import { Media as IMedia } from '@/components/media-manager/MediaManager';
import { useEffect, useMemo } from 'react';
import { EMPTY_AVATAR } from './Avatars';

interface AvatarDrawerProps {
  avatar?: Avatar;
  onClose: () => void;
}

const AvatarDrawer = ({ avatar, onClose }: AvatarDrawerProps) => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<{ organizationId: string }>();
  const isNewAvatar = useMemo(() => !avatar?.id, [avatar]);

  const formik = useFormik({
    initialValues: EMPTY_AVATAR as Avatar,
    onSubmit: async (values: Avatar) => {
      const isNewAvatar = !values?.id;

      const payload = {
        organizationId: organizationId ?? '',
        avatar: values as Avatar,
      };

      try {
        await dispatch(
          isNewAvatar ? createAvatar(payload) : updateAvatar(payload)
        );
      } catch (error) {
        console.error(error);
      } finally {
        onClose();
      }
    },
  });

  useEffect(() => {
    if (avatar) formik.setValues(avatar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatar]);

  const handleChangeAvatar = ({ name, size, timeCreated, src }: IMedia) => {
    const media = { name, size, timeCreated, src };
    formik.setFieldValue('media', media);
  };

  return (
    <Drawer
      anchor="right"
      open={!!avatar}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: 800,
        },
      }}
    >
      <Stack direction="row" justifyContent="space-between" padding={3}>
        <Typography variant="h3">
          {isNewAvatar ? 'Crear Avatar' : 'Editar Avatar'}
        </Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>
      <Divider />
      <Stack padding={'16px 32px'} spacing={2} flex={1} bgcolor={'#F2F2F2'}>
        <Paper sx={{ padding: 4 }}>
          <Stack spacing={2}>
            <TextField
              label="Título"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              fullWidth={true}
            />

            <MediaManager
              value={formik.values.media as IMedia}
              onChange={handleChangeAvatar}
            />
          </Stack>
        </Paper>
        <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
          <Button onClick={onClose} variant="text">
            Cancelar
          </Button>
          <Button color="success" onClick={formik.handleSubmit}>
            {isNewAvatar ? 'Crear ' : 'Editar '}
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default AvatarDrawer;
